import { render } from "./NoticeManageView.vue?vue&type=template&id=613c3054&scoped=true"
import script from "./NoticeManageView.vue?vue&type=script&lang=js"
export * from "./NoticeManageView.vue?vue&type=script&lang=js"

import "./NoticeManageView.vue?vue&type=style&index=0&id=613c3054&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-613c3054"]])

export default __exports__